const version = "2.9.3";

export { version };
//# sourceMappingURL=version.mjs.map
